import React, { useEffect } from 'react';
import './styles/noticeModal.scss';

export default function NoticeModal({ config, onClose }) {
  useEffect(() => {
    document.documentElement.classList.add('notice-modal-open');
    document.body.classList.add('notice-modal-open');

    return () => {
      document.documentElement.classList.remove('notice-modal-open');
      document.body.classList.remove('notice-modal-open');
    };
  }, []);

  if (!config) {
    return null;
  }

  const button = config.button || {};
  const target = button.target || '_blank';
  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

  return (
    <div className="noticeModal" role="dialog" aria-modal="true" aria-labelledby="notice-modal-title" onClick={onClose}>
      <section className="noticeModal__card" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="noticeModal__close" onClick={onClose} title="Fechar">
          Fechar
        </button>
        <h2 id="notice-modal-title" dangerouslySetInnerHTML={{ __html: config.title }} />
        <div className="noticeModal__content" dangerouslySetInnerHTML={{ __html: config.content }} />
        <a className="noticeModal__action" href={button.url} target={target} rel={rel} title={button.label}>
          {button.label}
        </a>
      </section>
    </div>
  );
}
